module.exports = __webpack_public_path__ + "media/images/sp/header/shop-13b88a227f9c012f9403cf43ba850122.svg";